import { Component } from '@angular/core';
import { NavController, NavParams, ToastController, LoadingController, AlertController, ModalController } from 'ionic-angular';

import { TenderMarketing, MasterMarketing as Master, UserMarketing as User } from '@providers/index';

import { SelectPage, PostTenderPage } from '../';

@Component({
  selector: 'page-form-tender',
  templateUrl: 'page.html'
})
export class FormTenderPage {

  tender : any = {
    bid_number:''
  };

  loading       : any;
  listCompany   : any =[];
  listBranch    : any =[];
  listSBU       : any =[];
  listDepartmen : any =[];
  listRate      : any =[];
  listStage     : any =[];
  listStatus    : any =[];
  listTenderType: any =[];
  list_currency : any =[];

  readyLoadMaster    =0;
  bid_edit           = false;
  form_edit          = false;
  akses        : any;
  
  constructor(
    public navCtrl     : NavController,
    public navParams   : NavParams,
    private toastCtrl  : ToastController,
    public loadingCtrl : LoadingController,
    public alertCtrl   : AlertController,
    public modalCtrl   : ModalController,
    public tenderApi   : TenderMarketing,
    public masterApi   : Master,
    public userApi     : User
  ) {
    this.akses = this.userApi.akses;
    if(this.navParams.get('tender')!=undefined){
      this.tender = this.navParams.get('tender');
    }
    if(this.navParams.get('form_type')=='edit'){
      this.form_edit = true;
    }
    if(this.navParams.get('bid_edit')==true){
      this.bid_edit = true;
    }
    console.log("bid check  => ", this.bid_edit);
    console.log("from edit  => ", this.form_edit);
    console.log("akses  => ", this.akses);
    this.getMaster();
  }

  showLoading(){
    this.loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    this.loading.present();
  }

  presentToast(msg){
    this.toastCtrl.create({
      message: msg,
      duration: 3000,
      position: 'top'
    }).present();
  }
 
  save(){    
    console.log(this.tender);
    if(this.tender.stage_id==16){
      let confirm = this.alertCtrl.create({
        title: 'Konfirmasi',
        subTitle: 'Tender dengan stage FINISH tidak bisa diubah kembali, lanjutkan ?',
        buttons: [
          {
            text: 'Tidak',
            handler: () => {
              console.log("tidak clicked");
            }
          },
          {
            text: 'Ya',
            handler: () => {
              console.log("yes clicked");
              this.save_post();
              if(this.tender.status_id == 10 || this.tender.status_id == 12){
                this.alertPostTender();
              }
            }
          }
        ]
      });
      confirm.present();
    }else{
      this.save_post();
      if(this.tender.status_id == 10 || this.tender.status_id == 12){
        this.alertPostTender();
      }
    }
  }

  save_post(){
      this.showLoading();

      if(this.tender.actual_oe < 1000000000){
        this.tender.ratings = 2
      }else if(this.tender.actual_oe >= 1000000000 && this.tender.actual_oe < 5000000000){
        this.tender.ratings = 3
      }else if(this.tender.actual_oe >= 5000000000 && this.tender.actual_oe < 25000000000){
        this.tender.ratings = 4
      }else if(this.tender.actual_oe > 25000000000){
        this.tender.ratings = 5
      }

      this.tenderApi.post(this.tender).subscribe((resp:any) => {    
        this.loading.dismiss();
        if(resp.success){
          this.presentToast(resp.msg);
          this.navCtrl.pop();
        }else{
          let alert = this.alertCtrl.create({
            title: 'Gagal Menyimpan',
            subTitle: resp.msg,
            buttons: ['Dismiss']
          });
          alert.present();
        }
      },(err) => {
        this.presentToast('Error');
        this.loading.dismiss();
      });
  }

  alertPostTender(){
    let form = this.alertCtrl.create({
      title   : 'Post Tender',
      subTitle: 'Fitur input Post Tender kini tersedia untuk tender dengan status Decline/Lose',
      buttons : [
        {
          text   : 'Try',
          handler: () => {
            this.navCtrl.push(PostTenderPage, {tender : this.tender});
          }
        },
        {
          text:'Close'
        }
      ]
    });
    form.present();
  }

  getStage(){
    let params = {};
    this.masterApi.stage(params).subscribe((resp:any) => {
      this.listStage = resp.data;
      this.readyLoadMaster++;
      if(this.readyLoadMaster == 9){
        this.loading.dismiss();
      }
    });
  }

  getStatus(){
    let params = {};
    this.masterApi.status(params).subscribe((resp:any) => {
      this.listStatus = resp.data;
      this.readyLoadMaster++;
      if(this.readyLoadMaster == 9){
        this.loading.dismiss();
      }
    });
  }

  getCompany(){
    let params = {};
    this.masterApi.company(params).subscribe((resp:any) => {
      this.listCompany = resp.data;
      this.readyLoadMaster++;
      if(this.readyLoadMaster == 9){
        this.loading.dismiss();
      }
    });
  }

  getSBU(){
    let params = {};
    this.masterApi.sbu(params).subscribe((resp:any) => {
      this.listSBU = resp.data;
      this.readyLoadMaster++;
      if(this.readyLoadMaster == 9){
        this.loading.dismiss();
      }
    });
  }

  getBranch(){
    console.log('b');
    let params = {};
    this.masterApi.branch(params).subscribe((resp:any) => {
      this.listBranch = resp.data;
      this.readyLoadMaster++;
      if(this.readyLoadMaster == 9){
        this.loading.dismiss();
      }
    });
  }

  getDepartmen(){
    let params = {};
    this.masterApi.department(params).subscribe((resp:any) => {
      this.listDepartmen = resp.data;
      this.readyLoadMaster++;
      if(this.readyLoadMaster == 9){
        this.loading.dismiss();
      }
    });
  }

  getRate(){
    let params = {};
    this.masterApi.rate(params).subscribe((resp:any) => {
      this.listRate = resp.data;
      this.readyLoadMaster++;
      if(this.readyLoadMaster == 9){
        this.loading.dismiss();
      }
    });
  }

  getTenderType(){
    let params = {};
    this.masterApi.getTenderType(params).subscribe((resp:any) => {
      this.listTenderType = resp.data;
      this.readyLoadMaster++;
      if(this.readyLoadMaster == 9){
        this.loading.dismiss();
      }
    });
  }

  getCurrency(){
    let params = {};
    this.masterApi.getCurrency(params).subscribe((resp:any) => {
      this.list_currency = resp.data;
      this.readyLoadMaster++;
      if(this.readyLoadMaster == 9){
        this.loading.dismiss();
      }
    });
  }

  getMaster(){
    this.showLoading();
    this.getCompany();
    this.getBranch();
    this.getSBU();
    this.getDepartmen();
    this.getStage();
    this.getRate();
    this.getStatus();
    this.getTenderType();
    this.getCurrency();
  }
}



// WEBPACK FOOTER //
// ./src/pages/marketing/form_tender/page.ts